<template>
    <div class="my-title">
        <van-icon class="left-icon" name="arrow-left" @click="goBack(isSubmit)"/>
        <div class="title-center">
            <h3>{{theTitle}}</h3>
            <slot></slot>
        </div>
        <van-icon class="right-icon" name="wap-home-o" @click="goHome"/>
    </div>
</template>

<script>
    export default {
        name: "fromTitle",
        data() {
            return {
                isWeixin: true
            }
        },
        methods: {
            goBack(isSubmit) {
                 history.go(-1)
            },
            goHome() {
                this.$router.push('/home/index')
            },
            isWeixn() {
                let ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    this.isWeixin = false
                    return true;
                } else {
                    this.isWeixin = true
                    return false;
                }
            },
        },
        props: ['theTitle', 'isSubmit'],
        mounted() {
            this.isWeixn()
        },
        deactivated () { //清除keep-alive的缓存
            this.$destroy(true)
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .my-title {
        box-sizing: border-box;
        padding: 12px 10px 0 10px;
        height: 44px;
        display: flex;
        justify-content: space-between;
        background: #f6f6f6;
        position: relative;

        .left-icon, .right-icon {
            line-height: 44px/2;
            font-size: 24px;
        }

        .title-center {
            display: flex;
            justify-content: center;

            > div {
                /*position: absolute;*/
                /*right: 28%;*/
                font-size: 18px;
                line-height: 44px/2;
            }
        }

        h3 {
            display: inline-block;
            margin: 0 auto;
            line-height: 20px;
            font-size: 18px;
            font-weight: normal;
            white-space: nowrap;
            line-height: 44px/2;
            padding-right: 8px;
        }
    }
</style>
